import { render } from "./MainCrm.vue?vue&type=template&id=5611a23e"
import script from "./MainCrm.vue?vue&type=script&lang=js"
export * from "./MainCrm.vue?vue&type=script&lang=js"

import "./MainCrm.vue?vue&type=style&index=0&id=5611a23e&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__